exports.init = ModalClearFormOnClose;

function ModalClearFormOnClose() {
  const $modals = $('.js-clear-form-on-close');

  $modals.on('hidden.bs.modal', function() {
    const $modal = $(this);
    const $form = $modal.find('form').first();
    const $anexos = $('#listagem-anexos').find('.anexos-item');
    const $anexosInput = $('#anexosObs');

    if ($anexos && $anexosInput) {
      $anexos.remove();
      $anexosInput.val('');
    }

    if ($form.length) {
      $form.get(0).reset();
      $form.find('[data-persistent-value]:not(.selectized)')
        .each((n, input) => {
          input.value = input.dataset.persistentValue;
        });

      // Limpa o campo de anexo
      $form.find('.file-picker__add--remove').trigger('click');

      // Remove todos os rateios
      clearRateios($form);
    }

    const $selectizes = $form.find('.selectized');
    if($selectizes.length) {
      $selectizes.each((n, el) => {
        el.selectize.clear()
        if(el.dataset.persistentValue && el.dataset.persistentValue.length) {
          el.selectize.setValue(el.dataset.persistentValue);
        }
      });
    }
  });
}

function clearRateios($form) {
  const rateiosElements = $form
    .find('#despesas-container')
    .find('.rateio');

  if (!rateiosElements.length) {
    return;
  }

  $form
    .find('#despesas-container')
    .find('.rateio')
    .remove();

  // Mostra o botão para adicionar um rateio
  $form
    .find('#despesas-container')
    .find('#novosRateios')
    .show();

  // Se a empresa utilizar o rateio como obrigatório
  // cria um input de rateio com o btn-remove escondido
  const rateioRequired = $form.find('#novosRateios').data('rateioRequired');

  if (rateioRequired) {
    $form
      .find('#despesas-container')
      .find('#novosRateios')
      .find('.add')
      .trigger('click');

    $form
      .find('#despesas-container')
      .find('.remove')
      .hide();
  }
}
